// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3SCVm","buttons":"PendingPaymentAlert_buttons__39o9y"};